import { StarsButton as Button, Translation } from '@ps/web-shared-components';
import React from 'react';

import { BaseHeader } from '@swf/poker';

import {
  TXTCLI_Show_Games,
  TXTCLI_Tournament_Filters,
  TXTMOB_Games_available
} from './TournamentsFilterModal.messages.json';
import styles from './TournamentsFilterModal.scss';

interface FiltersModalProps {
  onClose: () => void;
  tableRowsCount: number;
}

const TournamentsFilterModal: React.FC<React.PropsWithChildren<FiltersModalProps>> = ({
  children,
  onClose,
  tableRowsCount
}) => (
  <div className={styles.filtersModalContainer}>
    <BaseHeader
      headerClassName={styles.title}
      title={<Translation {...TXTCLI_Tournament_Filters} />}
    />
    <div className={styles.content}>
      {children}
      <div className={styles.bottom}>
        <div className={styles.tournamentsContainer}>
          <span className={styles.number}>{tableRowsCount}</span>
          <span className={styles.availableText}>
            <Translation {...TXTMOB_Games_available} />
          </span>
        </div>
        <Button
          variant="primary"
          translation={TXTCLI_Show_Games}
          size="large"
          className={styles.button}
          onClick={onClose}
        />
      </div>
    </div>
  </div>
);

export default TournamentsFilterModal;
